import { getImageSrc } from './local-util'
import { ScreenSizes } from './types'
export const playIcon = (width: any, height: any, videoIcon: any) => {
  let size = '20px'
  if (width >= ScreenSizes.XL) {
    size = '60px'
  } else if (width >= ScreenSizes.MD && width < ScreenSizes.XL) {
    size = '40px'
  }
  return { width: size, height: size, src: getImageSrc(videoIcon) }
}

export const getVideoThumbnail = (videoId: string, file = 'maxresdefault.jpg') => {
  //hqdefault.jpg
  return `https://i.ytimg.com/vi/${videoId}/${file}`
}
